"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailField = void 0;
const react_1 = __importDefault(require("react"));
const web_core_form_text_field_1 = require("@opus/web.core.form.text-field");
const EmailField = (props) => {
    return react_1.default.createElement(web_core_form_text_field_1.TextField, Object.assign({ type: "email", autoComplete: "email" }, props));
};
exports.EmailField = EmailField;
//# sourceMappingURL=email-field.js.map